export interface ExportColumn {
  groupName: string;
  columns: { title: string; field: string }[];
}
//Label "Volume" has changed to "Volunteers" for task(1592484)

export const exportColumns: { [key: string]: ExportColumn[] } = {
  todayArrivals: [
    {
      groupName: 'Today', columns: [
        { title: "Local ETD", field: "localETD" },
        { title: "Orig", field: "orig" },
        { title: "Dest", field: "dest" },
        { title: "Flt", field: "flightNumber" },
        { title: "Acft", field: "aircraftReg" },
        { title: "Payload Rank", field: "rank" },
        { title: "TTL PAX", field: "ttlpax" },
        { title: "Child", field: "childCount" },
        { title: "Wind Comp", field: "windComp" },
      ]
    },
    {
      groupName: 'Estimated', columns: [

        { title: "Weight", field: "weight" },
        { title: "Allowable Payload", field: "estAllowablePayload" },
        { title: "Volunteers", field: "estimatedVols" },
        { title: "Protected Seats", field: "estimatedProtectedSeats" },
      ]
    },
    {
      groupName: 'Actual', columns: [

        { title: "Allowable Payload", field: "actualAllowablePayload" },
        { title: "Volunteers", field: "actualVols" },
        { title: "Protected Seats", field: "actualProtectedSeats" },
      ]
    },
  ],

  todayDeparture: [
    {
      groupName: 'Today', columns: [
        { title: "Local ETD", field: "localETD" },
        { title: "Orig", field: "orig" },
        { title: "Dest", field: "dest" },
        { title: "Flt", field: "flightNumber" },
        { title: "Acft", field: "aircraftReg" },
        { title: "Payload Rank", field: "rank" },
        { title: "TTL PAX", field: "ttlpax" },
        { title: "Child", field: "childCount" },
        { title: "Wind Comp", field: "windComp" },
      ]
    },
    {
      groupName: 'Estimated', columns: [

        { title: "Weight", field: "weight" },
        { title: "Allowable Payload", field: "estAllowablePayload" },
        { title: "Volunteers", field: "estimatedVols" },
        { title: "Protected Seats", field: "estimatedProtectedSeats" },
      ]
    },
    {
      groupName: 'Actual', columns: [

        { title: "Allowable Payload", field: "actualAllowablePayload" },
        { title: "Volunteers", field: "actualVols" },
        { title: "Protected Seats", field: "actualProtectedSeats" },
      ]
    },
  ],
  tomorrowArrival: [
    {
      groupName: 'Tomorrow', columns: [
        { title: "Local ETD", field: "localETD" },
        { title: "Orig", field: "orig" },
        { title: "Dest", field: "dest" },
        { title: "Flt", field: "flightNumber" },
        { title: "Acft", field: "aircraftReg" },
        { title: "Payload Rank", field: "rank" },
        { title: "TTL PAX", field: "ttlpax" },
        { title: "Child", field: "childCount" },
        { title: "Wind Comp", field: "windComp" },
      ]
    },
    {
      groupName: '', columns: [

        { title: "Weight", field: "weight" },
        
      ]
    },
    {
      groupName: 'Estimated', columns: [

        { title: "Allowable Payload", field: "estAllowablePayload" },
        { title: "Volunteers", field: "estimatedVols" },
        { title: "Protected Seats", field: "estimatedProtectedSeats" },
      ]
    },
  ],
  tomorrowDeparture: [
    {
      groupName: 'Tomorrow', columns: [
        { title: "Local ETD", field: "localETD" },
        { title: "Orig", field: "orig" },
        { title: "Dest", field: "dest" },
        { title: "Flt", field: "flightNumber" },
        { title: "Acft", field: "aircraftReg" },
        { title: "Payload Rank", field: "rank" },
        { title: "TTL PAX", field: "ttlpax" },
        { title: "Child", field: "childCount" },
        { title: "Wind Comp", field: "windComp" },
      ]
    },
    {
      groupName: '', columns: [

        { title: "Weight", field: "weight" },
        
      ]
    },
    {
      groupName: 'Estimated', columns: [

        { title: "Allowable Payload", field: "estAllowablePayload" },
        { title: "Volunteers", field: "estimatedVols" },
        { title: "Protected Seats", field: "estimatedProtectedSeats" },
      ]
    },
  ],
};
